import * as colors from '@mehilainen/mds-tokens/colors';
import { baseTypography } from '@mehilainen/mds-tokens/typography';
import { toggleButtonGroupClasses, } from '@mui/material';
import { focusVisible, muiFocusVisibleCssClass } from '../shared';
export const getThemeToggleButton = (tokens) => {
    return {
        MuiToggleButton: {
            defaultProps: {
                size: 'medium',
            },
            styleOverrides: {
                root: {
                    color: colors.Gray700,
                    fontSize: tokens.uiElementTypography.toggleButtonText,
                    fontWeight: baseTypography.weight.Regular,
                    lineHeight: baseTypography.height.Small,
                    backgroundColor: colors.White,
                    textTransform: 'none',
                    borderColor: colors.Gray400,
                    [`&.${toggleButtonGroupClasses.middleButton}, &.${toggleButtonGroupClasses.lastButton}`]: {
                        borderColor: colors.Gray400,
                    },
                    [`&${muiFocusVisibleCssClass}`]: Object.assign(Object.assign({}, focusVisible), { outlineOffset: '2px', zIndex: '100' }),
                    '&.Mui-selected, &.Mui-selected:hover': {
                        backgroundColor: colors.Primary500,
                        color: colors.White,
                    },
                    '&.Mui-disabled': {
                        color: colors.Gray500,
                        border: '1px solid ' + colors.Gray400,
                        backgroundColor: colors.Gray100,
                    },
                },
                sizeSmall: {
                    height: tokens.uiElementToggleButton.sizeSmall.height,
                    padding: tokens.uiElementToggleButton.sizeSmall.padding,
                },
                sizeMedium: {
                    height: tokens.uiElementToggleButton.sizeMedium.height,
                    padding: tokens.uiElementToggleButton.sizeMedium.padding,
                },
                sizeLarge: {
                    height: tokens.uiElementToggleButton.sizeLarge.height,
                    padding: tokens.uiElementToggleButton.sizeLarge.padding,
                },
            },
        },
    };
};
